/**
 * Constantes pour le système de facturation LemonSqueezy
 */

/**
 * Lien de paiement LemonSqueezy du plan Solo (annuel).
 * Source unique : PricingHub, la page Tarifs, la page Abonnement et la modale
 * de quota (via useCheckout) ouvrent exactement le même checkout (#1470).
 */
export const SOLO_CHECKOUT_URL =
  "https://doodates.lemonsqueezy.com/checkout/buy/b8d2dcb2-4a21-4a0e-a2ed-e042175584c6";

/**
 * Lien Solo avec la traçabilité de la renonciation au droit de rétractation
 * (relue côté serveur au webhook LemonSqueezy via custom_data). Même
 * mécanisme pour toutes les entrées : page Tarifs, Abonnement, PricingHub,
 * modale de quota.
 */
export function buildSoloCheckoutUrl(waiverAcceptedAt: string): string {
  const url = new URL(SOLO_CHECKOUT_URL);
  url.searchParams.set("checkout[custom][waiver_accepted]", "true");
  url.searchParams.set(
    "checkout[custom][waiver_accepted_at]",
    waiverAcceptedAt,
  );
  return url.toString();
}

export const BILLING_PLANS = {
  FREE: "FREE",
  SOLO: "SOLO",
} as const;

export const BILLING_PLAN_NAMES = {
  [BILLING_PLANS.FREE]: "DooDates Gratuit",
  [BILLING_PLANS.SOLO]: "DooDates Solo",
} as const;

export const BILLING_LABELS = {
  UPGRADE_TO_SOLO: "billing.labels.upgradeToSolo",
  CHANGE_PLAN: "billing.labels.changePlan",
  CANCEL_RENEWAL: "billing.labels.cancelRenewal",
  RESUME_RENEWAL: "billing.labels.resumeRenewal",
  CONFIRM_CANCEL: "billing.labels.confirmCancel",
  KEEP_PLAN: "billing.labels.keepPlan",
} as const;

export const BILLING_STATUS = {
  ACTIVE: "ACTIVE",
  CANCELED: "CANCELED",
  PAST_DUE: "PAST_DUE",
} as const;

export const BILLING_STATUS_CONFIG = {
  [BILLING_STATUS.ACTIVE]: {
    label: "Actif",
    className: "bg-success/15 text-success border-success/30",
  },
  [BILLING_STATUS.CANCELED]: {
    label: "Annulé (fin de période)",
    className: "bg-warning/15 text-warning border-warning/30",
  },
  [BILLING_STATUS.PAST_DUE]: {
    label: "Paiement en échec",
    className: "bg-destructive/15 text-destructive border-destructive/30",
  },
} as const;

export const BILLING_TEST_IDS = {
  SUBSCRIPTION_PAGE: "account-subscription-page",
  SUBSCRIPTION_SUMMARY_CARD: "subscription-summary-card",
  SUBSCRIPTION_STATUS_BADGE: "subscription-status-badge",
  SUBSCRIPTION_UPGRADE_TO_SOLO_BUTTON: "subscription-upgrade-to-solo-button",
  SUBSCRIPTION_CHANGE_PLAN_BUTTON: "subscription-change-plan-button",
  SUBSCRIPTION_CANCEL_RENEWAL_BUTTON: "subscription-cancel-renewal-button",
  SUBSCRIPTION_RESUME_RENEWAL_BUTTON: "subscription-resume-renewal-button",
  SUBSCRIPTION_CANCEL_CONFIRMATION: "subscription-cancel-confirmation",
  SUBSCRIPTION_CONFIRM_CANCEL_BUTTON: "subscription-confirm-cancel-button",
  SUBSCRIPTION_KEEP_PLAN_BUTTON: "subscription-keep-plan-button",
} as const;

export const BILLING_MESSAGES = {
  LOADING: "Chargement de vos informations d'abonnement...",
  ERROR_TITLE: "Mon abonnement",
  ERROR_DESCRIPTION: "Impossible de charger vos informations d'abonnement.",
  ERROR_MESSAGE:
    "Une erreur est survenue lors du chargement de votre abonnement.",
  RETRY: "Réessayer",
  SUCCESS_CANCELED: "Renouvellement annulé",
  SUCCESS_RESUMED: "Renouvellement réactivé",
  CONFIRM_CANCEL_TITLE: "Confirmer l'annulation du renouvellement",
  CONFIRM_CANCEL_MESSAGE:
    "Votre abonnement restera actif jusqu'à la fin de la période, puis ne sera pas renouvelé automatiquement.",
} as const;

export const BILLING_CACHE_CONFIG = {
  STALE_TIME: 5 * 60 * 1000, // 5 minutes
} as const;
